import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { forkJoin, of } from 'rxjs';
import { AtpcoSubCode, AtpcoGroup } from './atpco.model';

@Injectable({ providedIn: 'root' })
export class AtpcoService {
  path: string = '/api';
  constructor(private apiService: ApiService) { }

  getAmenity(carrierCode: string, amenityType: string, cabins: string[], locale: string = 'en-US') {
    return this.apiService.post<{ translation: string; displayTextKey: string }[]>(`/api/v2/amenities/display_text_keys/search`, {carrier_code: carrierCode, amenity_type: amenityType, locale: locale, cabin: cabins.join(',')});
  }

  getSubCodes(airlineId: number) {
    return this.apiService
      .getParams<AtpcoSubCode[]>(`${this.path}/atpco_optional_services_industry_sub_codes`, {
        airline_id: airlineId,
      });
  }

  getGroups() {
    return this.apiService.get<AtpcoGroup[]>(`${this.path}/atpco_groups`);
  }

  getSubGroups() {
    return this.apiService.get<AtpcoGroup[]>(`${this.path}/atpco_sub_groups`);
  }

  getProcessedSubCodes(airlineId: number) {
    return forkJoin([
      this.getSubCodes(airlineId).pipe(catchError(() => of([]))),
      this.getGroups().pipe(catchError(() => of([]))),
      this.getSubGroups().pipe(catchError(() => of([]))),
    ]).pipe(
      map((responses: [AtpcoSubCode[], AtpcoGroup[], AtpcoGroup[]]) => {
        responses[0].forEach((sub_code) => {
          let sub_group;
          if (sub_code) {
            sub_code.tokens = (sub_code?.commercial_name ?? '').split(' ');
            sub_code.tokens.push(sub_code.code);
            sub_code.group_value = responses[1].find(group => group.code === sub_code.group_code)?.value ?? null;
            sub_code.tokens = sub_code.group_value
              ? sub_code.tokens.concat(sub_code.group_value.split(' '))
              : sub_code.tokens;
            if (sub_code.sub_group_code) {
              sub_group = responses[2].find(subGroup => subGroup.code === sub_code.sub_group_code);
              if (sub_group) {
                sub_code.tokens = sub_code.tokens.concat(sub_group.value.split(' '));
                sub_code.sub_group_value = sub_group.value;
              }
            }
            if (sub_code.standard_category_id) {
              return sub_code.tokens.push(sub_code.standard_category_id);
            }
          }
        });

        return responses[0];
      }),
    );
  }
}
